import { useState, useEffect } from "react";
import { Download, X } from "lucide-react";
import { usePWAInstall } from "../lib/usePWAInstall";

export const PWAInstallBanner = () => {
  const { canInstall, promptInstall } = usePWAInstall();
  const [dismissed, setDismissed] = useState(
    sessionStorage.getItem("valora_pwa_dismissed") === "1"
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (canInstall && !dismissed) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
    setShow(false);
  }, [canInstall, dismissed]);

  if (!show) return null;

  return (
    <div className="fixed inset-x-3 bottom-4 z-[60] mx-auto max-w-md fade-up">
      <div className="flex items-center gap-3 rounded-2xl brand-navy p-3 pr-2 shadow-2xl">
        <div className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-white/10">
          <Download className="h-5 w-5 text-emerald-300" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-white">Instala VALORA en tu dispositivo</p>
          <p className="truncate text-xs text-slate-300">Acceso rápido, sin tiendas de apps.</p>
        </div>
        <button
          data-testid="pwa-install-banner-button"
          onClick={promptInstall}
          className="flex-none rounded-full bg-emerald-500 px-4 py-2 text-sm font-bold text-white transition-transform hover:scale-105"
        >
          Instalar
        </button>
        <button
          onClick={() => {
            setDismissed(true);
            sessionStorage.setItem("valora_pwa_dismissed", "1");
          }}
          className="flex-none rounded-full p-2 text-slate-400 hover:text-white"
          aria-label="Cerrar"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
